import * as types from '../../constants';

const initialState = [];

export default function industries(state = initialState, action) {
  switch (action.type) {
    case types.GET_INDUSTRIES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
